import { ModuleWithProviders, NgModule } from '@angular/core';
import { RegularStorageService } from '@shared/modules/storage/data-access/regular-storage.service';
import { BrowserRegularStorageService } from '@shared/modules/storage/data-access/browser-regular-storage.service';
import { SyncKeyValueStorageService } from '@shared/modules/storage/data-access/sync-key-value-storage.service';
import { LocalStorageSyncKeyValueStorageService } from '@shared/modules/storage/data-access/local-storage-sync-key-value-storage.service';

/**
 * Binds the abstract storage tokens to their browser-backed implementations (IndexedDB for async
 * record storage, localStorage for synchronous key/value storage). Import
 * `BrowserStorageModule.forRoot()` once per application window (web + Electron renderer).
 */
@NgModule()
export class BrowserStorageModule {
  static forRoot(): ModuleWithProviders<BrowserStorageModule> {
    return {
      ngModule: BrowserStorageModule,
      providers: [
        { provide: RegularStorageService, useClass: BrowserRegularStorageService },
        { provide: SyncKeyValueStorageService, useClass: LocalStorageSyncKeyValueStorageService }
      ]
    };
  }
}
